import RenewedImpactModal from './RenewedImpactModal.vue'

export default RenewedImpactModal
